import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import {
    IRequestData,
    IHorizon,
    IFilterHorizons,
} from '../../../types';
import { AuthContext } from '../../../contexts/Auth/AuthContext';
import apiService from '../../../services/apiService';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

interface IHorizonProps {
    examId: string | undefined
    horizon: IHorizon
    horizonFilters: IFilterHorizons
    renewHorizon: (data: Array<IHorizon> | undefined) => void
}

export default function HorizonWaxinessItem(props: IHorizonProps) {
    const styles = useStyles();
    const auth = React.useContext(AuthContext);
    const [waxinessGrade, setWaxinessGrade] = useState<string>('0');
    const [waxinessQuantity, setWaxinessQuantity] = useState<string>('0');
    const [waxinessUpdate, setWaxinessUpdate] = useState<boolean>(false);

    async function updateHorizon() {
        if (auth !== undefined && props.examId !== undefined && props.horizon !== undefined) {
            let request_data: IRequestData = {
                horizon_id: props.horizon.id,
                exam_id: parseInt(props.examId),
            };

            if (
                waxinessGrade !== null &&
                waxinessGrade !== '0' &&
                props.horizon.waxiness_grade !== `${waxinessGrade}`
            ) {
                request_data['waxiness_grade'] = `${waxinessGrade}`;
            }
            if (
                waxinessQuantity !== null &&
                waxinessQuantity !== '0' &&
                props.horizon.waxiness_quantity !== `${waxinessQuantity}`
            ) {
                request_data['waxiness_quantity'] = `${waxinessQuantity}`;
            }

            try {
                await apiService.put(
                    'exams/horizon',
                    request_data
                ).then((response) => {
                    if (response !== undefined && response.status === 200) {
                        props.renewHorizon(response.data.data as Array<IHorizon>);
                    }
                }).catch(() => {
                });
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        if (waxinessUpdate === true) {
            updateHorizon();
            setWaxinessUpdate(false);
        }
        return () => setWaxinessUpdate(false);
        // eslint-disable-next-line
    }, [waxinessUpdate]);

    useEffect(() => {
        if (props.horizon !== undefined) {
            setWaxinessGrade((props.horizon.waxiness_grade === null ? '0' : props.horizon.waxiness_grade));
            setWaxinessQuantity((props.horizon.waxiness_quantity === null ? '0' : props.horizon.waxiness_quantity));
        }
        // eslint-disable-next-line
    }, [props]);

    return (
        <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            key={`${props.horizon.id}${props.horizon.name}`}
            className={styles.view_horizon_waxiness}
        >
            <Grid item xs={12} className={styles.view_horizon_waxiness_title}>
                <Typography className={styles.text_horizon_waxiness}>
                    <strong>{props.horizon.name}</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_waxiness_subtitle}>
                <Typography className={styles.text_horizon_waxiness_subtitle}>
                    Grau
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_waxiness_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={waxinessGrade ? waxinessGrade : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setWaxinessGrade(`${event.target.value}`);
                        setWaxinessUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.waxiness_grade.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_waxiness_subtitle}>
                <Typography className={styles.text_horizon_waxiness_subtitle}>
                    Quantidade
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_waxiness_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={waxinessQuantity ? waxinessQuantity : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setWaxinessQuantity(`${event.target.value}`);
                        setWaxinessUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.waxiness_quantity.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}